<span [matTooltip]="versionsSummary$ | async">
    {{value$ | async}}
</span>
